import React, { Component, InputHTMLAttributes, KeyboardEvent } from "react";
import { WebFormFieldProps } from "./index";
import { readValue, writeValue } from "@eres/forms/Utils";
import DatePickerInput, { Props as DatePickerInputProps } from "./JQDatePicker";
import FormField from "./WebFormField";
import { getValidationClass } from "./Utils";
import { DefaultProps } from "@eres/forms";

export interface Props extends WebFormFieldProps<string, Date> {
	inputClassName?: string;
	errorInputClass?: string;
	placeHolder?: string;
	type?: string;
	cursorPositioner?: ( previousValue: string | null, previousPosition: number, value: string ) => number;
	maxLength?: number;
	inputProps?: InputHTMLAttributes<HTMLInputElement>;
	mode?: "input" | "text";
	extraOpts: any;
}

interface State {
	isFocus: boolean;
}

class DateInputField extends Component<Props, State> {
	static defaultProps: DefaultProps<Props> = {
		inputClassName: "form-control ltr-text-field calendar-icon",
		errorInputClass: "form-input-error is-invalid",
		type: "text",
		mode: "input",
		extraOpts: {},
	};

	constructor( props: Props ) {
		super( props );
		this.state = {
			isFocus: false,
		};
	}

	onKeyUp = ( e: KeyboardEvent<HTMLInputElement> ) => {
		let inp = e.target as HTMLInputElement;
		let v = inp.value;
		inp.value = "" + v;
	};

	onChange = ( value?: Date ) => {
		if ( this.props.onValueChange ) {
			this.props.onValueChange( value! );
		}
		writeValue( this.props, value, () => {
			if ( this.props.onValueUpdated ) {
				this.props.onValueUpdated( value );
			}
		} );
	};

	render() {
		const {
			id, inputClassName, placeHolder, error, errorInputClass, type, disabled, extraInputClassName,
			inputProps, required
		} = this.props;
		let cValue = readValue( this.props );

		let inputStyle = getValidationClass( this.state.isFocus, this.props, cValue, error );
		let iClass = inputClassName + ( extraInputClassName ? ` ${ extraInputClassName }` : "" ) +
			inputStyle + ( error ? ` ${ errorInputClass }` : "" );
		const inpProps: DatePickerInputProps = {
			id: id,
			value: cValue as Date,
			onDateSet: this.onChange,
			inputClassName: iClass,
			placeholder: placeHolder,
			inputProps: {
				disabled: disabled,
				onBlur: this.onBlur,
				onFocus: this.onFocus,
				placeholder: "dd-mm-yyyy",
				...( inputProps ),
			},
			opts: {
				changeMonth: true,
				changeYear: true,
				dateFormat: "dd-mm-yy",
				showOn: "both",
				buttonText: "",
				showAnim: "slideDown",
				...this.props.extraOpts,
			}
		};
		let ele = <DatePickerInput { ...inpProps }/>;
		if ( this.props.mode === "text" ) {
			ele = <div className={ "form-text-container" } id={ this.props.id }>
				<span className={ "form-text-data" }>{ inpProps.value }</span>
			</div>;
		}
		return (
			<FormField { ...this.props }>
				{ ele }
				{ this.props.children }
			</FormField>
		);
	}

	private onFocus = () => {
		this.setState( { isFocus: true } );
	};

	private onBlur = () => {
		this.setState( { isFocus: false } );
	};
}


export default DateInputField;
